import { Button, Paper, Stack, Text } from '@mantine/core'
import { type Icon } from '@tabler/icons-react'
import Link from 'next/link'
import { type FC, type ReactNode } from 'react'

export interface HomeCardProps {
  children: ReactNode
  external?: boolean
  href?: string
  IconComponent?: Icon
  onClick?: () => void
  title: string
}

export const HomeCard: FC<HomeCardProps> = ({ children, external = false, href, IconComponent, onClick, title }) => (
  <Paper
    display='flex'
    p='lg'
  >
    <Stack
      align='center'
      justify='space-between'
      w='100%'
    >
      <Text
        color='brand-red'
        size='lg'
        weight='bold'
      >
        {title}
      </Text>
      <Text
        align='center'
        size='sm'
      >
        {children}
      </Text>
      <Button
        color='brand-red'
        // @ts-ignore
        component={external || onClick ? 'a' : Link}
        href={href}
        leftIcon={IconComponent && <IconComponent size={16} />}
        onClick={onClick}
        size='sm'
        target={external ? '_blank' : undefined}
        title={title}
      >
        {title}
      </Button>
    </Stack>
  </Paper>
)
